export const ScheduleListCardSkeleton: React.FC = () => (
  <div className='animate-pulse flex flex-col items-between justify-center gap-[15px] text-left bg-surface border border-skeleton-border px-4 py-4 rounded-[35px] overflow-hidden relative'>
    <div className='absolute top-0 right-0 flex items-center justify-end gap-[5px] px-4 py-2 bg-skeleton-hi/40 rounded-bl-[15px]'>
      <div className='bg-skeleton-hi h-[15px] w-[60px] rounded-lg' />
      <div className='relative'>
        <div className='absolute top-[1px] left-[1px] w-[13px] h-[13px] rounded-[10px] bg-skeleton-hi' />
        <div className='w-[15px] h-[15px] rounded-[10px]' />
      </div>
    </div>
    <div className='ml-[15px] w-[50%] h-[22px] rounded-lg bg-skeleton-hi' />
    <div className='flex items-end justify-between text-secondary-content bg-skeleton-hi/40 pl-5 pr-4 py-4 rounded-[35px]'>
      <div className='grid md:grid-cols-2 gap-[12px] grow'>
        <div className='flex flex-col gap-[8px]'>
          <div className='bg-skeleton-hi w-[50%] h-[16px] rounded-lg' />
          <div className='bg-skeleton-hi w-[60%] h-[19px] rounded-lg' />
        </div>
        <div className='flex flex-col gap-[8px]'>
          <div className='bg-skeleton-hi w-[50%] h-[16px] rounded-lg' />
          <div className='bg-skeleton-hi w-[60%] h-[19px] rounded-lg' />
        </div>
        <div className='flex flex-col gap-[8px] md:col-span-2'>
          <div className='bg-skeleton-hi w-[50%] h-[16px] rounded-lg' />
          <div className='bg-skeleton-hi w-[60%] h-[19px] rounded-lg' />
        </div>
        <div className='flex flex-col gap-[8px]'>
          <div className='bg-skeleton-hi w-[50%] h-[16px] rounded-lg' />
          <div className='bg-skeleton-hi w-[60%] h-[19px] rounded-lg' />
        </div>
      </div>
      <div className='bg-skeleton-hi w-[50px] h-[50px] rounded-[25px]' />
    </div>
  </div>
)
